var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpeedLimitWarningVae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "speed_x5F_limit_x5F_warning_x5F_vae",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "speed_x5F_limit_x5F_warning_x5F_vae_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 48,
    cy: 48,
    r: 46
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B33229"
    },
    d: "M48,14c18.778,0,34,15.222,34,34S66.778,82,48,82S14,66.778,14,48S29.222,14,48,14 M48,4 C23.738,4,4,23.738,4,48s19.738,44,44,44s44-19.738,44-44S72.262,4,48,4L48,4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.02,38h3.321v16.551h8.154v2.673H20.02V38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.736,43.616h3.24v13.608h-3.24V43.616z M33.763,38h3.213v3.051h-3.213V38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.134,43.616h3.078v1.674c0.252-0.612,0.675-1.08,1.269-1.404c0.594-0.324,1.35-0.486,2.268-0.486 c1.062,0,1.921,0.18,2.579,0.54c0.657,0.36,1.138,0.882,1.445,1.566c0.287-0.684,0.77-1.206,1.444-1.566 c0.675-0.36,1.507-0.54,2.497-0.54c1.62,0,2.785,0.423,3.497,1.269c0.71,0.847,1.066,2.062,1.066,3.645v8.91h-3.24v-8.181 c0-1.098-0.171-1.845-0.513-2.241c-0.343-0.396-0.945-0.594-1.81-0.594s-1.476,0.189-1.836,0.567 c-0.36,0.378-0.549,1.071-0.566,2.079v8.37h-3.241v-8.181c0-1.098-0.171-1.845-0.513-2.241c-0.342-0.396-0.945-0.594-1.809-0.594 c-0.864,0-1.476,0.189-1.836,0.567c-0.36,0.378-0.549,1.071-0.567,2.079v8.37h-3.213V43.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.302,43.616h3.239v13.608h-3.239V43.616z M62.328,38h3.213v3.051h-3.213V38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.594,43.616h1.809v-3.24h3.105v3.24h3.779v2.673h-3.779v6.453c0,0.793,0.157,1.323,0.472,1.594 c0.315,0.27,0.868,0.404,1.661,0.404h1.62v2.484h-2.214c-1.675,0-2.881-0.355-3.618-1.066c-0.738-0.711-1.107-1.886-1.107-3.523 v-6.345h-1.728V43.616z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeedLimitWarningVae);
export default __webpack_public_path__ + "static/media/icon-speed_limit_warning_vae.a2343a9204962cd870ada4abbbd9f986.svg";
export { ForwardRef as ReactComponent };